import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Box,
  Icon,
  ModalCloseButton,
} from "@chakra-ui/react";
import { FiAlertTriangle } from "react-icons/fi";

interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  subTitleText?: string;
  bodyText?: string;
  loading?: boolean;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

const WithDrawalDocModal: React.FC<DeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  loading = false,
  title = "Confirm Deletion",
  subTitleText = "Please Confirm?",
  bodyText = "Are you sure you want to delete this item? This action cannot be undone.",
  confirmButtonText = "Yes",
  cancelButtonText = "No",
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <ModalOverlay />
      <ModalContent
        borderRadius="md"
        boxShadow="lg"
        bg="white"
        _dark={{ bg: "gray.800" }}
      >
        <ModalHeader
          display="flex"
          alignItems="center"
          borderBottomWidth="1px"
          pb={4}
          color="teal.400"
          fontSize="xl"
        >
          <Icon as={FiAlertTriangle} boxSize={6} mr={3} />
          {title}
        </ModalHeader>
        <ModalCloseButton mt={2}/>
        <ModalBody py={6}>
          <Box textAlign="center">
            <Text
              fontSize={{ base: "lg", md: "xl" }}
              fontWeight="500"
              color="red"
              textAlign="center"
            >
              {bodyText}
            </Text>
            <Text
              fontSize={{ base: "lg", md: "xl" }}
              mt={2}
              fontWeight={600}
              color={"red"}
            >
              {subTitleText}
            </Text>
          </Box>
        </ModalBody>

        <ModalFooter
          gap={6}
          mt={1}
          justifyItems="center"
          justifyContent="center"
          my={2}
        >
          <Button
            type="submit"
            w="70px"
            bg="teal.300"
            color="white"
            _hover={{
              bg: "teal.400",
            }}
            isLoading={loading}
            onClick={onConfirm}
          >
            {confirmButtonText}
          </Button>
          <Button onClick={onClose} colorScheme="red" color="white" w="70px">
            {cancelButtonText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default WithDrawalDocModal;
